export default {
  en: {
    'components.summary-table-ecsl.data-row.troubleshoot-tooltip': 'Troubleshoot',
  },
};
